import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    width: "100%",
    padding: "20px",
    direction: "ltr",
  },

  container_rtl: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    width: "100%",
    padding: "20px",
    direction: "rtl",
  },

  close_container: {
    position: "absolute",
    top: 10,
    right: 10,
    cursor: "pointer",
  },
  close_container_rtl: {
    position: "absolute",
    top: 10,
    left: 10,
    cursor: "pointer",
  },

  title: {
    color: "#000000",
    fontSize: "20px",
    fontWeight: 300,
    letterSpacing: 0,
    marginBottom: "8px",
  },

  description: {
    color: "#353535",
    fontSize: "14px",
    letterSpacing: 0,
    width: "67%",
  },

  mobile_description: {
    color: "#353535",
    fontSize: "14px",
    letterSpacing: 0,
    width: "100%",
  },

  close_icon: {
    color: "#424242",
  },

  leaves_container: {
    position: "absolute",
    bottom: -5,
    right: theme.direction === "ltr" ? 50 : "none",
    left: theme.direction === "rtl" ? 50 : "none",
  },
  impact_container: {},
}));

export default useStyles;
